module.exports = __webpack_public_path__ + "img/logo-light.01a644fb.png";